/**
 * Dé Pratas — <dp-payment>
 *
 * Mantém as condições de pagamento (parcelamento / Pix) em sincronia com a
 * variante selecionada.
 *
 * Segue o mesmo contrato do <product-price> nativo (assets/product-price.js):
 * o tema re-renderiza a seção no servidor e entrega o HTML pronto em
 * `event.promise`. Aqui só trocamos o nosso pedaço por aquele HTML — nenhum
 * cálculo de preço acontece no cliente, então a formatação de moeda continua
 * sendo a do filtro `money` do Liquid.
 */

const PRODUCT_SELECT = 'shopify:product:select';

class DpPayment extends HTMLElement {
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(PRODUCT_SELECT, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(PRODUCT_SELECT, this.#handleProductSelect);
    this.#section = null;
  }

  #handleProductSelect = (event) => {
    // Cards de produto se re-renderizam por inteiro, então ignoramos o evento
    // vindo deles — mesmo guard do <product-price>.
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          // Evento de outro produto na mesma seção (ex.: recomendações).
          return;
        }

        const fresh = html.querySelector(`dp-payment[data-block-id="${this.dataset.blockId}"]`);
        if (!fresh) return;

        this.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[dp-payment] Event promise rejected:', error);
      });
  };
}

// Módulos ES executam uma vez por URL, mas o guard protege contra registro
// duplicado se o arquivo for importado por outro caminho.
if (!customElements.get('dp-payment')) {
  customElements.define('dp-payment', DpPayment);
}
